export default __webpack_public_path__ + "static/media/elevate-red-poster-3.c6c4ce31.jpg";